module.exports = __webpack_public_path__ + "img/smilingFaces_brand_logo.d84e1f0e.png";